// Lives in its own file (not inline in assetsFeature.ts) so route factories
// and screens can import these constants without a circular import back
// through assetsFeature.ts -> presentation/routes -> here.
const ASSET_TYPES_LIST = "core.asset_management.asset_type_management_list";
const ASSETS_LIST = "core.asset_management.asset_management_list";

export const ASSET_TYPES_VIEW = `${ASSET_TYPES_LIST}.view`;
export const ASSET_TYPES_CREATE = `${ASSET_TYPES_LIST}.create`;
export const ASSET_TYPES_UPDATE = `${ASSET_TYPES_LIST}.update`;
export const ASSET_TYPES_DELETE = `${ASSET_TYPES_LIST}.delete`;

export const ASSETS_VIEW = `${ASSETS_LIST}.view`;
export const ASSETS_CREATE = `${ASSETS_LIST}.create`;
export const ASSETS_UPDATE = `${ASSETS_LIST}.update`;
export const ASSETS_DELETE = `${ASSETS_LIST}.delete`;
